//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 头部登录按钮
// @author Rico
// import Storage from "@/utils/storage";
import { mapState } from "vuex";

export default {
  name: "HeaderLogin",
  componentName: "HeaderLogin",
  computed: {
    ...mapState({
      userInfo: (state) => state.user?.userInfo,
      identityToken: (state) => state.user?.identityToken,
    }),
    isLogined() {
      return this.identityToken && this.userInfo;
    },
    displayName() {
      return (
        this.userInfo &&
        (this.userInfo.nickname ||
          this.userInfo.email ||
          this.userInfo.telephone)
      );
    },
  },
  methods: {
    handleCommand(command) {
      if (command === "logout") {
        this.$store.dispatch("Logout");
      } else if (command === "myaccount") {
        const lang = document.documentElement.lang;
        const identityToken = localStorage.identityToken;
        window.location.href = `https://myaccount.apowersoft.com?lang=${lang}&identity_token=${identityToken}`;
      }
    },
    gotoLogin() {
      this.$showModal(
        () => ({
          component: import(
            /* webpackPrefetch: true */
            /*  webpackChunkName: "Account" */
            `@/components/letsView/Account.vue`
          ),
        }),
        {
          width: "500px",
          height: "600px",
        },
        {
          successCallback: () => {
            this.$hideModal("Account");
          },
        },
        "Account"
      );
    },
  },
};
